import { Col, Icon, Spin } from 'antd';
import React from 'react';

const Loading: React.FC = () => {
  return (
    <Col className="loading__content">
      <Spin
        indicator={<Icon type="loading" style={{ fontSize: 24 }} spin={true} />}
        tip="Loading..."
      />
    </Col>
  );
};

export default Loading;
